"use client";

import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";

export default function OdooAbout() {
  return (
    <section className="py-24 px-6 sm:px-12 lg:px-24 relative z-10 text-white">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-16">

          {/* Text Content */}
          <motion.div
            className="lg:w-1/2"
          >
            <h2 className="text-2xl md:text-4xl font-extrabold leading-tight mb-6 text-white tracking-tighter uppercase">
              Run Smarter. <span className="text-[#f1833b]">Scale Faster.</span><br />
              <span className="text-gray-300">With CodeQlik.</span>
            </h2>
            <div className="space-y-4 text-gray-400 text-base leading-relaxed">
              <p>
                At CodeQlik, we turn business ambitions into measurable results. As a certified <span className="text-[#f1833b] font-bold underline decoration-2 underline-offset-4">Odoo Silver Partner</span>, we implement and configure Odoo ERP solutions tailored to your operations.
              </p>
              <p>
                Our expertise spans the full Odoo suite, backed by global best practices and dedicated end-to-end support to ensure your long-term success.
              </p>
              <p className="font-bold text-white border-l-4 border-[#f1833b] pl-4 italic text-sm">
                Ready to unlock your business’s true potential? Let’s make it happen.
              </p>
            </div>

            <motion.div className="mt-8">
              <a
                href="/contact"
                className="group inline-flex items-center gap-3 px-6 py-2 bg-[#f1833b] text-black font-black rounded-full hover:bg-[#ef7b2f] transition-all shadow-[0_10px_30px_rgba(241,131,59,0.3)] uppercase tracking-widest text-[10px]"
              >
                Connect With Us
                <span className="text-lg transition-transform group-hover:translate-x-1 group-hover:-translate-y-1">↗</span>
              </a>
            </motion.div>
          </motion.div>

          {/* Image Content */}
          <motion.div
            className="lg:w-1/2 flex justify-center"
          >
            {/* Using the newly downloaded Odoo infographic */}
            <div className="relative group">
              <div className="absolute inset-0 bg-[#f1833b]/10 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
              <Image
                src="/assets/img/odoo/odoo-infographic.png"
                alt="Odoo Ecosystem Infographic"
                width={650}
                height={450}
                className="w-full max-w-[650px] h-auto object-contain drop-shadow-[0_20px_50px_rgba(0,0,0,0.3)] relative z-10"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
